import ReactCountryFlag from 'react-country-flag';

export const Flag = ({ code }: { code: string }) => (
  <ReactCountryFlag
    countryCode={code}
    svg
    style={{
      width: '1em',
      height: '1em',
      display: 'inline-block',
      lineHeight: '1em',
      verticalAlign: 'middle',
      marginBottom: '.5em',
    }}
    title={code}
    aria-label={code}
  />
);

export default Flag;
